import { AvatarGroup } from "@mui/material";
import React, { useEffect } from "react";
import { colorProps } from "./colorProps";
import AvatarItem from "./item";
import { variantProp } from "./variantProp";

interface Props {
  users: any[];
  variant?: string;
  size?: string;
  max?: number;
  sx?: any;
}

export default function UserAvatarList(props: Props) {
  const { variant, size, users, max, sx } = props;
  const [sizeProperty, setSizeProperty] = React.useState<any>();
  const [colorProperty, setColorProperty] = React.useState<any>();

  useEffect(() => {
    setSizeProperty(variantProp[size ?? "large"]);
    setColorProperty(colorProps[variant ?? "colored"]);
  }, []);

  return (
    users && (
      <AvatarGroup
        total={users.length}
        max={max}
        sx={{
          "& .MuiAvatarGroup-avatar": {
            width: sizeProperty?.width,
            height: sizeProperty?.height,
            marginInlineStart: `${users.length > 1} ? ${variant === "regular" ? "12px" : "16px"} : '0'`,
            background: colorProperty?.bgColor,
            color: colorProperty?.textColor,
            border: colorProperty?.borderStyle,
            fontSize: sizeProperty?.fontSize,
            fontWeight: "bold",
            zIndex: 4
          },
          ...sx
        }}
      >
        {users.map((user: any, index: any) => (
          <AvatarItem
            key={user.hltId}
            user={user}
            index={index}
            sizeProperty={sizeProperty}
            colorProperty={colorProperty}
            zIndex={index + 1}
          ></AvatarItem>
        ))}
      </AvatarGroup>
    )
  );
}
